import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    const fetchSettings = async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings(data);
            if (data?.meta_title) document.title = data.meta_title;
            if (data?.meta_description) {
                const m = document.querySelector('meta[name="description"]');
                if (m) m.setAttribute("content", data.meta_description);
            }
            if (data?.favicon_url) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement("link");
                    link.rel = "icon";
                    document.head.appendChild(link);
                }
                link.href = data.favicon_url;
            }
        } catch (e) {
            console.error("Failed to load settings", e);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, refresh: fetchSettings, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
